export function minutesToTimeInput(value) {
    if (value === -1) {
        return '~';
    }

    if (value === undefined || value === null || value === '') {
        return;
    }

    let hours = 0;
    if (value >= 0) {
        hours = Math.floor(value / 60);
    } else if (value < 0) {
        hours = Math.ceil(value / 60);
    }

    let minutes = Math.abs(value % 60);

    if (isNaN(minutes)) {
        minutes = 0;
    }

    if (!isNaN(hours)) {

        if (minutes.toString().length === 1) {
            minutes = '0' + minutes.toFixed(0);
        }

        return hours.toFixed(0) + ':' + (typeof minutes === 'number' ? minutes.toFixed(0) : minutes);
    }
}
